import { FormStatus } from '../types';

export type FormStatusAction = 'pause' | 'resume' | 'close';

const ACTION_TO_STATUS: Record<FormStatusAction, FormStatus> = {
  pause: 'paused',
  resume: 'published',
  close: 'closed'
};

export const mapFormStatusActionToApiStatus = (
  action: FormStatusAction
): FormStatus => ACTION_TO_STATUS[action];

export default mapFormStatusActionToApiStatus;
